<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import UiButton from '@/Components/UI/UiButton.vue'

const props = defineProps({
  conversationId: { type: Number, required: true },
  status:         { type: String, required: true },
  pipelineStage:  { type: String, default: null },
  taken:          { type: Boolean, default: false },
})
const emit = defineEmits(['changed'])

const { t } = useI18n()
const busy = ref(false)

const RESOLVE_ALLOWED_STAGES = [ 'in_progress', 'rental_cancelled' ]
const resolveBlocked = computed(() => {
  if (!props.taken) return true
  return props.pipelineStage !== null && !RESOLVE_ALLOWED_STAGES.includes(props.pipelineStage)
})
const blockReasonKey = computed(() => {
  if (!props.taken) return 'inbox.thread.takeFirst'
  return 'inbox.thread.resolveBlocked'
})

const token = () => document.querySelector('meta[name="csrf-token"]')?.content

const setStatus = async (next) => {
  busy.value = true
  try {
    const res = await fetch(`/inbox/conversations/${props.conversationId}/status`, {
      method: 'PATCH',
      headers: {
        'Content-Type':  'application/json',
        'Accept':        'application/json',
        'X-CSRF-Token':  token() || '',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ status: next })
    })
    if (res.ok) emit('changed', next)
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <div class="flex items-center gap-2">
    <UiButton
      v-if="status === 'open'"
      variant="secondary"
      size="sm"
      :loading="busy"
      :disabled="resolveBlocked"
      :title="resolveBlocked ? t(blockReasonKey) : null"
      @click="setStatus('resolved')"
    >
      {{ t('inbox.thread.resolve') }}
    </UiButton>
  </div>
</template>
